export default {
  setReleases(state, releases) {
    state.releases = releases;
  }
};
